import { FC } from "react";

import { TranslatedLink } from "components/atoms/TranslatedLink/TranslatedLink";

import { ITag } from "@types";

import s from "./Tag.module.scss";

export const Tag: FC<ITag> = ({ link, label }) => {
  return (
    <TranslatedLink link={link} className={s.Tag}>
      {label}
    </TranslatedLink>
  );
};
